import React, { createContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import RouteConstants from "../../../constants/routeConstants.json";
import {
  viewTenantApi,
  tenantEditApi,
  subscriptionPlanListApi,
} from "../../../api/Api";
import {
  validateName,
  validateEmail,
  validateMobileNumber,
  validateNameWithNum,
} from "../../../utils/service";
import { useCookies } from "react-cookie";

export const EditTenantContext = createContext({});
export const EditTenantContextProvider = ({ children }) => {
  const [spinnerStatus, setSpinnerStatus] = useState(false);
  const [tenantName, setTenantName] = useState("");
  const [tenantEmail, setTenantEmail] = useState("");
  const [tenantPhone, setTenantPhone] = useState();
  const [tenantOrgName, setTenantOrgName] = useState("");
  const [tenantOrgEmail, setTenantOrgEmail] = useState("");
  const [tenantOrgType, setTenantOrgType] = useState("");
  const [tenantLocation, setTenantLocation] = useState("");
  const [tenantStatus, setTenantStatus] = useState("");
  const [subscriptionPlan, setSubscriptionPlan] = useState("");
  const [editSuccessPopup, setEditSuccessPopup] = useState(false);
  const [editErrorPopup, setEditErrorPopup] = useState(false);
  const [cookies, setCookie, removeCookie] = useCookies(["user"]);
  const [subscriptionPlansList, setSubscriptionPlansList] = useState([]);

  const [errorPopup, setErrorPopup] = useState(false);
  const [errorAlertMessage, setErrorAlertMessage] = useState("");
  const [validationErrors, setValidationErrors] = useState({});

  const [statusValue, setStatusValue] = useState();
  const [buttonText, setButtonText] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const adminId = location?.state?.id;

  const goToLogin = () => {
    removeCookie("x-access-token");
    navigate(RouteConstants.LOGIN);
  };

  // console.log("subscriptionPlan", subscriptionPlan);
  // console.log("errorPopup", errorPopup);
  const goToTenantList = () => {
    navigate(RouteConstants.TENANT_LIST);
  };

  const goToTenantViewPage = (id) => {
    navigate(RouteConstants.VIEW_TENANT, { state: { id } });
  };

  useEffect(() => {
    viewTenantDetails(adminId);
    getSubscriptionPlans();
  }, []);

  const onChangePhone = (event) => {
    setTenantPhone(event.target.value);
  };

  const onChangeOrgName = (event) => {
    setTenantOrgName(event.target.value);
  };
  const onChangeOrgEmail = (event) => {
    setTenantOrgEmail(event.target.value);
  };
  const onChangeOrgType = (event) => {
    setTenantOrgType(event.target.value);
  };
  const onChangeLocation = (event) => {
    setTenantLocation(event.target.value);
  };
  const onChangeSubsriptionPlan = (event) => {
    // console.log("onchange", event.target.value);
    setSubscriptionPlan(event.target.value);
  };

  const transformedPlans = subscriptionPlansList.map((plan) => ({
    id: plan._id, // Keep the id for backend submission
    displayName: `${plan.name} (${plan.billingCycle})`, // Create a formatted name
  }));

  // console.log("transformedPlans", transformedPlans);

  const handleBlur = (field) => {
    const fieldErrors = {};
    // if (field === "name") {
    //   fieldErrors.name = validateName(tenantName) ? "" : "Invalid name";
    // }
    // if (field === "email") {
    //   fieldErrors.email = validateEmail(tenantEmail)
    //     ? ""
    //     : "Invalid email format";
    // }
    if (field === "phone") {
      fieldErrors.phone = validateMobileNumber(tenantPhone)
        ? ""
        : "Invalid phone number. Must be 10 digits";
    }
    if (field === "organizationName") {
      fieldErrors.organizationName = validateName(tenantOrgName)
        ? ""
        : "Invalid organization name";
    }
    if (field === "organizationEmail") {
      fieldErrors.organizationEmail = validateEmail(tenantOrgEmail)
        ? ""
        : "Invalid email format";
    }
    if (field === "organizationType") {
      fieldErrors.organizationType = tenantOrgType.trim()
        ? ""
        : "Organization type is required";
    }
    if (field === "location") {
      fieldErrors.location = tenantLocation.trim()
        ? ""
        : "Location is required";
    }
    if (field === "subscriptionPlan") {
      fieldErrors.subscriptionPlan = subscriptionPlan
        ? ""
        : "Subscription plan is required";
    }

    // Update validation errors for the specific field
    setValidationErrors((prevErrors) => ({ ...prevErrors, ...fieldErrors }));
  };

  const getSubscriptionPlans = async () => {
    try {
      setErrorPopup(false);
      setSpinnerStatus(true);
      const listApiData = await subscriptionPlanListApi();
      // console.log("subscriptionPlans", listApiData.data.data.subscriptionPlans);
      setSubscriptionPlansList(listApiData.data.data.subscriptionPlans);
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      console.log("error", error);

      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";
      // console.log("errorMessage in getSubscriptionPlans", errorMessage);

      setStatusValue(responseStatus);
      setErrorAlertMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }

      setSpinnerStatus(false);
    }
    setSpinnerStatus(false);
  };

  const viewTenantDetails = async (adminId) => {
    try {
      setSpinnerStatus(true);
      const tenantInfo = await viewTenantApi(adminId);
      setErrorPopup(false);
      if (tenantInfo?.status === 200) {
        setSpinnerStatus(false);
        setTenantName(tenantInfo?.data?.data?.tenant?.name);
        setTenantEmail(tenantInfo?.data?.data?.tenant?.email);
        setTenantPhone(tenantInfo?.data?.data?.tenant?.phone);
        setTenantOrgName(tenantInfo?.data?.data?.tenant?.organizationName);
        setTenantOrgEmail(tenantInfo?.data?.data?.tenant?.organizationEmail);
        setTenantOrgType(tenantInfo?.data?.data?.tenant?.organizationType);
        setTenantStatus(tenantInfo?.data?.data?.tenant?.status);
        setTenantLocation(tenantInfo?.data?.data?.tenant?.location);
        setSubscriptionPlan(
          tenantInfo?.data?.data?.tenant?.subscriptionPlan?._id
        );
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";
      // console.log("errorMessage in viewTenantDetails", errorMessage);

      setStatusValue(responseStatus);
      setErrorAlertMessage(errorMessage);
      setErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }
      setSpinnerStatus(false);
    }
    setSpinnerStatus(false);
  };

  const editTenantDetails = async (event) => {
    event.preventDefault();
    const tenantDetails = {
      // name: tenantName,
      // email: tenantEmail,
      phone: tenantPhone,
      organizationName: tenantOrgName,
      organizationEmail: tenantOrgEmail,
      organizationType: tenantOrgType,
      location: tenantLocation,
      subscriptionPlan: subscriptionPlan,
    };

    const errors = {
      // name: validateName(tenantName) ? "" : "Invalid name",
      // email: validateEmail(tenantEmail) ? "" : "Invalid email format",
      phone: validateMobileNumber(tenantPhone)
        ? ""
        : "Invalid phone number. Must be 10 digits",
      organizationName: validateNameWithNum(tenantOrgName)
        ? ""
        : "Invalid organization name",
      organizationEmail: validateEmail(tenantOrgEmail)
        ? ""
        : "Invalid email format",
      organizationType: tenantOrgType.trim()
        ? ""
        : "Organization type is required",
      location: tenantLocation.trim() ? "" : "Location is required",
      subscriptionPlan: subscriptionPlan ? "" : "Subscription plan is required",
    };

    // Update state with errors
    setValidationErrors(errors);
    const hasErrors = Object.values(errors).some((error) => error !== "");
    if (hasErrors) return;

    try {
      setSpinnerStatus(true);

      const tenantEditApiResponse = await tenantEditApi(adminId, tenantDetails);
      // console.log("tenantEditApiResponse", tenantEditApiResponse);
      if (tenantEditApiResponse?.status === 200) {
        setSpinnerStatus(false);
        setEditSuccessPopup(true);
        setErrorAlertMessage(tenantEditApiResponse?.data?.message);
      }
    } catch (error) {
      const responseStatus = error?.response?.data?.statusCode;
      const errorMessage =
        error?.response?.data?.message || "Something went wrong...";
      console.log("errorMessage in edit", errorMessage);
      setStatusValue(responseStatus);
      setErrorAlertMessage(errorMessage);
      setEditErrorPopup(true);

      if (responseStatus === 400) {
        setButtonText("Try Again");
      } else if (responseStatus === 401 || responseStatus === 403) {
        setButtonText("Login");
      } else {
        setButtonText("Try Again");
      }
      setSpinnerStatus(false);
    }
    setSpinnerStatus(false);
  };

  const providerValue = {
    spinnerStatus,
    tenantName,
    tenantEmail,
    tenantPhone,
    tenantOrgName,
    tenantOrgEmail,
    tenantOrgType,
    tenantLocation,
    tenantStatus,
    subscriptionPlan,
    errorPopup,
    setErrorPopup,
    errorAlertMessage,
    adminId,
    viewTenantDetails,
    goToTenantViewPage,
    onChangeOrgName,
    onChangePhone,
    onChangeOrgEmail,
    onChangeOrgType,
    onChangeLocation,
    onChangeSubsriptionPlan,
    transformedPlans,
    handleBlur,
    validationErrors,
    editTenantDetails,
    editSuccessPopup,
    setEditSuccessPopup,
    setSubscriptionPlan,
    editErrorPopup,
    setEditErrorPopup,
    goToTenantList,

    buttonText,
    setButtonText,
    goToLogin,
    statusValue,
    setStatusValue,
  };

  return (
    <EditTenantContext.Provider value={providerValue}>
      {children}
    </EditTenantContext.Provider>
  );
};
